ACC.completionrequest = {

    /////////// vars ////////////
    FormId: '#completionRequestForm',
    validateFormFields: $('.validateForm .amds-form-field'),
    formFieldValidationClass: 'amds-form-field-validation',
    formFieldValidationErrorClass: 'amds-form-field-validation-error',
    formFieldDisabledClass: 'amds-form-field-disabled',
    formFieldErrorMsg: 'amds-form-field__errormsg',
    triggerSubmit: false,
    ////////////////////////

    _autoload: [
        ["init", $("#completionRequestForm").length > 0],
        "InputChange"
    ],

    init: function () {
        $(document).on('submit', "#completionRequestForm", function (e) {
            e.preventDefault();

            var $fields = $(this).find('.amds-form-field'),
                isError = false;

            $.each($fields, function (index, field) {
                //reset
                $(field)
                    .find('.amds-form-field__input, .amds-form-field__textarea')
                    .removeClass(ACC.completionrequest.formFieldValidationErrorClass).end()
                    .find('.' + ACC.completionrequest.formFieldErrorMsg).hide().html('');

                var that = $(field),
                    fieldClass = that.attr('class').split(' ');

                if (!that.hasClass(ACC.completionrequest.formFieldDisabledClass)) {
                    $.each(fieldClass, function (index, classString) {
                        let validationClass = ACC.completionrequest.formFieldValidationClass + '__',
                            isErrorField = false;

                        if (classString.toLowerCase().indexOf(validationClass) != -1) {
                            isErrorField = ACC.completionrequest.validateFormField(classString.split(validationClass)[1], that);
                        }

                        if (isErrorField) {
                            isError = true;
                        }
                    });
                }
            });

            if (!isError) {
                let _form = $("#completionRequestForm");
                $.ajax({
                    type: "POST",
                    url: _form.attr('action'),
                    data: _form.serialize(),
                    success: function (response) {
                        response.isSuccess ? (window.location.href = "?successMsg=true") : ACC.completionrequest.handelServerErrors(response.fieldsError);
                    },
                    error: function (xhr, textStatus, error) {
                        console.log(error);
                    }
                });
            }
        });
    },
    handelServerErrors: function (fieldsError) {
        fieldsError.map(field => {
            $(ACC.completionrequest.FormId).find('#'+field.name)
                .addClass(ACC.completionrequest.formFieldValidationErrorClass).end()
                    .find(`.amds-form-field-validation__${field.name} .${ACC.completionrequest.formFieldErrorMsg}`)
                        .hide().html(field.message).slideDown();
        });
    },
    validateFormField: function (validation, field) {
        var isError = false;
        switch (validation) {

            case 'mandatory':
                $.each(field.find('input, select, textarea'), function (index, input) {
                    if (!$(input).hasClass('excluded') && $(input).val() === '') {
                        isError = true;
                        $(input).addClass(ACC.completionrequest.formFieldValidationErrorClass);

                        let errormsgDiv = $(input).siblings('.' + ACC.completionrequest.formFieldErrorMsg);
                        errormsgDiv.hide().html(errorsMsg['all']['mandatory']).slideDown();
                    }
                });
                break;


            case 'email':
                let input = field.find('input'),
                    emailVal = input.val(),
                    regex = new RegExp(emailRegex);

                if (emailVal !== "") {
                    if (!regex.test(emailVal)) {
                        isError = true;
                        $(input).addClass(ACC.completionrequest.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.completionrequest.formFieldErrorMsg).hide().html(errorsMsg['email']['notvalid']).slideDown();
                    } else {
                        $(input).removeClass(ACC.completionrequest.formFieldValidationErrorClass);
                        $(input).siblings('.' + ACC.completionrequest.formFieldErrorMsg).slideUp(100);
                    }
                }
                break;

            case 'phone':
                let fields = field.find('.amds-form-field-mini');

                $.each(fields, function (index, fields) {
                    var input = $(fields).find('input'),
                        inputVal = input.val(),
                        regex = /^(\+|\d)[0-9]{7,16}$/;

                    input.val(inputVal = $.trim(inputVal));

                    if (inputVal !== "") {
                        if (!regex.test(inputVal)) {
                            isError = true;
                            $(input).addClass(ACC.completionrequest.formFieldValidationErrorClass);
                            $(input).siblings('.' + ACC.completionrequest.formFieldErrorMsg).hide().html(errorsMsg['all']['notvalid']).slideDown();
                        } else {
                            $(input).removeClass(ACC.completionrequest.formFieldValidationErrorClass);
                            $(input).siblings('.' + ACC.completionrequest.formFieldErrorMsg).slideUp(100);
                        }
                    }
                });
                break;

        }

        return isError;
    },

    InputChange: function () {
        $('.' + ACC.completionrequest.formFieldValidationClass).on('keyup', function () {
            $(this).removeClass(ACC.completionrequest.formFieldValidationErrorClass);
            $(this).parent().find('.' + ACC.completionrequest.formFieldErrorMsg).slideUp(100);
        });
    },


}
